import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { modalClose } from '../../actions/modals';
import ModalItem from './ModalItem';

const mapStateToProps = state => ({ modals: state.modals });
const matchDispatchToProps = dispatch => {
  return bindActionCreators({ modalClose }, dispatch);
};

class Modals extends Component {
  render() {
    const { modals, modalClose } = this.props 
    
    return (
      modals.map( (modal, idx) => {
        return <ModalItem {...modal} modalClose={modalClose} key={idx} />
      })
    );
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(Modals);


// WEBPACK FOOTER //
// ./src/components/modals/Modals.js